export const GET_ALL_MANAGERS = "GET_ALL_MANAGERS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_MANAGERS = "START_LOADING_MANAGERS";
export const STOP_LOADING_MANAGERS = "STOP_LOADING_MANAGERS";
export const ERROR_LOADING_MANAGERS = "ERROR_LOADING_MANAGERS";